// extracted by mini-css-extract-plugin
module.exports = {"tab_container":"games_tabbed-module--tab_container--39E8W","tab_button":"games_tabbed-module--tab_button--JFd-N"};